import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'
import isEmpty from 'lodash/isEmpty'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import Table from '@vtex/styleguide/lib/EXPERIMENTAL_Table'
import useTableMeasures from '@vtex/styleguide/lib/EXPERIMENTAL_Table/hooks/useTableMeasures'
import { getInstoreConfig } from '@/checkout-instore-legacy/utils/configUtils'
import { getJsonColumnsData } from './schema'

function ItemShippingTable({ items, titleId, intl }) {
  const { productPage } = getInstoreConfig()

  const columnsSchema = useMemo(
    () => getJsonColumnsData(intl, productPage.freigthTable),
    [intl, productPage.freigthTable]
  )
  const measures = useTableMeasures({
    size: items.length,
    density: 'regular',
  })

  return !isEmpty(items) ? (
    <div>
      <div className="pb4 lh-solid b c-on-base">
        <FormattedMessage id={titleId} />
      </div>
      <Table columns={columnsSchema} items={items} measures={measures} />
    </div>
  ) : null
}

ItemShippingTable.propTypes = {
  items: PropTypes.array,
  titleId: PropTypes.string.isRequired,
  intl: intlShape.isRequired,
}

export default injectIntl(ItemShippingTable)
